import { render, staticRenderFns } from "./MoveSummaryView.vue?vue&type=template&id=3452d741&scoped=true"
import script from "./MoveSummaryView.vue?vue&type=script&lang=js"
export * from "./MoveSummaryView.vue?vue&type=script&lang=js"
import style0 from "./MoveSummaryView.vue?vue&type=style&index=0&id=3452d741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452d741",
  null
  
)

export default component.exports